import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

interface ErrorFieldProps {
  /**
   * Additional classes for the error field
   */
  additionalClasses?: string;
  /**
   * Component test id
   */
  testId?: string;
}

const ErrorField = ({ additionalClasses, testId }: ErrorFieldProps) => {
  const field = useFieldContext();
  const errors = useFieldErrors(field.name);

  return (
    <div
      className={twMerge('text-sm text-red', additionalClasses)}
      {...getTestProps(testId)}
    >
      {errors}
    </div>
  );
};

export default ErrorField;
